import { Box } from '@mui/material'
import { FC } from 'react'
import { GrantsDashboardStats } from './GrantsDashboardStats'
import { Projects } from './Projects'
import { RecentMatches } from './RecentMatches'

export const Dashboard: FC = () => {
  return (
    <Box width="100%">
      <GrantsDashboardStats />
      <Projects />
      <RecentMatches />
    </Box>
  )
}
